module.exports = __webpack_public_path__ + "img/all.29df3f60.svg";